module.exports = __webpack_public_path__ + "c304c0bd624ab317e979eb6fc776f2fc.pdf";